import React from 'react';
import { StaticQuery, graphql } from "gatsby"

const Step4 = (props) => (
  <StaticQuery
         query={graphql`
            query {
               allWpPage(filter: {slug: {eq: "quote"}}) {
                  edges {
                    node {
                      slug
                      TeamlanceQuote {
                        quotes {
                          description
                          emailLabel
                          emailPlaceholder
                          nameLabel
                          namePlaceholder
                          projectDescriptionLabel
                          projectDescriptionPlaceholder
                          projectLabel
                          projectPlacehoder
                          title
                          quoteSteps {
                            buttonText
                            description
                            heading
                            iconSvg
                            stepDescription
                            stepOptions {
                              description
                              iconSvg
                              title
                            }
                            stepTitle
                            title
                          }
                        }
                      }
                    }
                  }
                }
            }
         `}
         render={data => {
           return(
            <section className="share-sec">
            <div className="share-top">
               <svg width={366} height={185} viewBox="0 0 366 185" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M51.8221 167.583L-35.3348 87.7328L-40 34.2603L358.287 64.1671L83.1531 173.347C72.4676 177.588 60.2986 175.349 51.8221 167.583Z" fill="#D8F4FF" />
              </svg>
            </div>
            <div className="container my-5">
              <div className="row">
                <div className="desktop-hidden w-100">
                  <div className="d-flex m-steps col-12 justify-content-center align-items-center  mb-4">
                    <div className="mobile-steps ">
                      <p className="mb-0">4/6</p>
                      <span dangerouslySetInnerHTML={{__html:data.allWpPage.edges[0].node.TeamlanceQuote.quotes.quoteSteps[3].iconSvg}}></span>
                    </div>
                    <div className="quote-labels mr-4">
                         <h6 className="mb-0">{data.allWpPage.edges[0].node.TeamlanceQuote.quotes.quoteSteps[3].title}</h6>
                         <p className="mb-0">{data.allWpPage.edges[0].node.TeamlanceQuote.quotes.quoteSteps[3].description}</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-5 col-lg-4 mobile-hidden leftQuoteMenu">
                  <div className="quote-items d-flex justify-content-end align-items-center">
                    <div className="quote-labels mr-4">
                        <h6 className="mb-0">{data.allWpPage.edges[0].node.TeamlanceQuote.quotes.quoteSteps[0].title}</h6>
                        <p className="mb-0">{data.allWpPage.edges[0].node.TeamlanceQuote.quotes.quoteSteps[0].description}</p>
                    </div>
                    <span dangerouslySetInnerHTML={{__html:data.allWpPage.edges[0].node.TeamlanceQuote.quotes.quoteSteps[0].iconSvg}} className="quote-icons quote-active "></span>
                    <div className="circle-icon active">
                      <div className="vx">-</div>
                    </div>
                    <div className="quote-border" />
                  </div>
                  <div className="quote-items d-flex justify-content-end align-items-center">
                    <div className="quote-labels mr-4">
                        <h6 className="mb-0">{data.allWpPage.edges[0].node.TeamlanceQuote.quotes.quoteSteps[1].title}</h6>
                        <p className="mb-0">{data.allWpPage.edges[0].node.TeamlanceQuote.quotes.quoteSteps[1].description}</p>
                    </div>
                    <span dangerouslySetInnerHTML={{__html:data.allWpPage.edges[0].node.TeamlanceQuote.quotes.quoteSteps[1].iconSvg}} className="quote-icons quote-active"></span>
                    <div className="circle-icon active">
                      <div className="vx">-</div>
                    </div>
                    <div className="quote-border" />
                  </div>
                  <div className="quote-items d-flex justify-content-end align-items-center">
                    <div className="quote-labels mr-4">
                         <h6 className="mb-0">{data.allWpPage.edges[0].node.TeamlanceQuote.quotes.quoteSteps[2].title}</h6>
                          <p className="mb-0">{data.allWpPage.edges[0].node.TeamlanceQuote.quotes.quoteSteps[2].description}</p>
                    </div>
                    <span dangerouslySetInnerHTML={{__html:data.allWpPage.edges[0].node.TeamlanceQuote.quotes.quoteSteps[2].iconSvg}} className="quote-icons quote-active"></span>
                    <div className="circle-icon active">
                      <div className="vx">-</div>
                    </div>
                    <div className="quote-border" />
                  </div>
                  <div className="quote-items d-flex justify-content-end align-items-center">
                    <div className="quote-labels mr-4 ">
                        <h6 className="mb-0">{data.allWpPage.edges[0].node.TeamlanceQuote.quotes.quoteSteps[3].title}</h6>
                        <p className="mb-0">{data.allWpPage.edges[0].node.TeamlanceQuote.quotes.quoteSteps[3].description}</p>
                    </div>
                    <span dangerouslySetInnerHTML={{__html:data.allWpPage.edges[0].node.TeamlanceQuote.quotes.quoteSteps[3].iconSvg}} className="quote-icons quote-active"></span>
                    <div className="circle-icon active">
                      <div className="vx">-</div>
                    </div>
                    <div className="quote-border" />
                  </div>
                  <div className="quote-items d-flex justify-content-end align-items-center">
                    <div className="quote-labels mr-4">
                             <h6 className="mb-0">{data.allWpPage.edges[0].node.TeamlanceQuote.quotes.quoteSteps[4].title}</h6>
                              <p className="mb-0">{data.allWpPage.edges[0].node.TeamlanceQuote.quotes.quoteSteps[4].description}</p>
                    </div>
                    <span dangerouslySetInnerHTML={{__html:data.allWpPage.edges[0].node.TeamlanceQuote.quotes.quoteSteps[4].iconSvg}} className="quote-icons"></span>
                    <div className="circle-icon">
                      <div className="vx">-</div>
                    </div>
                    <div className="quote-border" />
                  </div>
                  <div className="quote-items d-flex justify-content-end align-items-center">
                    <div className="quote-labels mr-4">
                         <h6 className="mb-0">{data.allWpPage.edges[0].node.TeamlanceQuote.quotes.quoteSteps[5].title}</h6>
                         <p className="mb-0">{data.allWpPage.edges[0].node.TeamlanceQuote.quotes.quoteSteps[5].description}</p>
                    </div>
                    <span dangerouslySetInnerHTML={{__html:data.allWpPage.edges[0].node.TeamlanceQuote.quotes.quoteSteps[5].iconSvg}} className="quote-icons"></span>
                    <div className="circle-icon ">
                      <div className="vx">-</div>
                    </div>
                    <div className="quote-border" />
                  </div>
                </div>
                <div className="col-md-7 col-lg-7 rightQuoteMenu">
                  <div className="items-iner">
                    <p className="steps mb-0 mobile-hidden">{data.allWpPage.edges[0].node.TeamlanceQuote.quotes.quoteSteps[3].stepTitle}</p>
                    <h4>{data.allWpPage.edges[0].node.TeamlanceQuote.quotes.quoteSteps[3].heading}</h4>
                    <p className="mb-4">{data.allWpPage.edges[0].node.TeamlanceQuote.quotes.quoteSteps[3].stepDescription}</p>
                    <hr />
                    <form className="mt-4 quote-form  ">
                      <div className="form-group float-label-control">
                        <label htmlFor>Enter project name</label>
                        <input type="text" className="form-control" placeholder="Project Name" />
                      </div>
                      <div className="form-group float-label-control">
                        <label htmlFor>Project Description</label>
                        <input type="text" className="form-control" placeholder="Describe project" />
                      </div>
                      <div className="col-12 p-0 d-flex justify-content-between align-items-center btn-spacing">
                        <div onClick={()=>{props.previousStep()}} className="back-arow"><svg width={18} height={14} viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M8.11117 13.6736C8.24006 13.5447 8.31246 13.3698 8.31246 13.1875C8.31246 13.0052 8.24006 12.8303 8.11117 12.7014L3.09725 7.68752H16.5625C16.7448 7.68752 16.9197 7.61508 17.0486 7.48615C17.1776 7.35722 17.25 7.18235 17.25 7.00002C17.25 6.81768 17.1776 6.64281 17.0486 6.51388C16.9197 6.38495 16.7448 6.31252 16.5625 6.31252H3.09725L8.11117 1.29864C8.2401 1.1697 8.31252 0.994826 8.31252 0.812486C8.31251 0.630145 8.24007 0.455276 8.11113 0.326348C7.98219 0.197419 7.80731 0.124992 7.62497 0.125C7.44263 0.125008 7.26776 0.19745 7.13883 0.32639L0.951332 6.51389C0.949087 6.51611 0.947241 6.51859 0.945038 6.52086C0.93146 6.53479 0.918287 6.5491 0.905929 6.56412C0.899027 6.57251 0.893005 6.58141 0.886564 6.59005C0.879603 6.59937 0.87236 6.60851 0.865853 6.61821C0.85916 6.62819 0.853349 6.6386 0.847223 6.64888C0.841872 6.65786 0.836229 6.66663 0.831256 6.6759C0.825738 6.68623 0.821038 6.69688 0.816066 6.70742C0.811425 6.71724 0.806541 6.72689 0.802366 6.73692C0.79817 6.74707 0.794771 6.75748 0.791078 6.7678C0.787176 6.77863 0.783022 6.78937 0.779664 6.80045C0.776559 6.81073 0.774272 6.82118 0.771649 6.83158C0.768796 6.84291 0.765607 6.85416 0.76332 6.8657C0.760949 6.8777 0.759523 6.88979 0.757802 6.90183C0.756354 6.91198 0.754424 6.92193 0.75342 6.93216C0.751196 6.95474 0.75 6.97736 0.75 7.00002C0.75 7.02268 0.751196 7.04529 0.75342 7.06787C0.754427 7.07811 0.756357 7.08805 0.757802 7.0982C0.759521 7.11025 0.760949 7.12233 0.76332 7.13433C0.765607 7.14587 0.768796 7.15712 0.771649 7.16845C0.774272 7.17886 0.776559 7.1893 0.779664 7.19959C0.783022 7.21066 0.787176 7.22141 0.791078 7.23223C0.794773 7.24255 0.79817 7.25296 0.802366 7.26312C0.806541 7.27314 0.811429 7.28279 0.816066 7.29261C0.821038 7.30315 0.825738 7.31381 0.831256 7.32413C0.836229 7.3334 0.841872 7.34217 0.847223 7.35115C0.853349 7.36143 0.85916 7.37184 0.865853 7.38182C0.872358 7.39152 0.879596 7.40067 0.886564 7.40998C0.89301 7.41862 0.899025 7.42752 0.905929 7.43591C0.918497 7.45123 0.931904 7.46579 0.945751 7.47997C0.947702 7.48195 0.949339 7.48417 0.951332 7.48614L7.13883 13.6736C7.20268 13.7375 7.27847 13.7881 7.36189 13.8227C7.4453 13.8572 7.53471 13.875 7.625 13.875C7.71529 13.875 7.8047 13.8572 7.88811 13.8227C7.97153 13.7881 8.04732 13.7375 8.11117 13.6736Z" fill="#8DB4C4" />
                          </svg>
                        </div>
                        <button onClick={()=>{props.nextStep()}} className="btn btn-default waves-effect waves-light next-step">Next Step</button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <div className="share-bottom quote-svg">
              <svg width={488} height={191} viewBox="0 0 488 191" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M505.679 145.456L-1141.05 391.43L-1135.95 425.56L365.13 0.63037L491.67 51.6707L505.679 145.456Z" fill="#F4F8FF" />
              </svg>
            </div>
           </section>
           )
         }}
      />       
)

export default Step4;